<template>
  <div>
    <div
      class="media-cell cellBox"
      :style="more1 ? 'height: 76px' : 'height: 30px'"
    >
      <p style="height: 76px; width: 85px; float: left">业务类型：</p>
      <el-checkbox-group v-model="pindao2" @change="onCheckbox_pindao2">
        <el-checkbox label="不限" @change="onCheckAll_pindao2"
          >不限</el-checkbox
        >
        <el-checkbox
          v-for="(item, index) in channelList"
          :key="index"
          :label="item.value"
          >{{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div class="moreBox" v-if="!more1" @click="more1 = true">更多</div>
    </div>
    <div class="media-cell cellBox" style="height: 46px">
      <p style="height: 110px; width: 85px; float: left">所属平台：</p>
      <el-checkbox-group v-model="menhu2" @change="onCheckbox_menhu2">
        <el-checkbox label="不限" @change="onCheckAll_menhu2">不限</el-checkbox>
        <el-checkbox
          v-for="(item, index) in portalList"
          :key="index"
          :label="item.value"
          >{{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="media-cell">
      <p style="height: 40px; width: 85px; float: left">其他选项：</p>
      <el-checkbox-group v-model="other2" @change="onCheckbox_other2">
        <el-checkbox label="不限" @change="onCheckAll_other2">不限</el-checkbox>
        <el-checkbox label="工作日">工作日</el-checkbox>
        <el-checkbox label="周六日">周六日</el-checkbox>
        <el-checkbox label="节假日">节假日</el-checkbox>
        <el-checkbox label="提前预约">提前预约</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="media-cell">
      价格区间：
      <el-radio v-model="jiage2" label="0-999999">不限</el-radio>
      <el-radio v-model="jiage2" label="0-20">0-20</el-radio>
      <el-radio v-model="jiage2" label="21-50">21-50</el-radio>
      <el-radio v-model="jiage2" label="51-75">51-75</el-radio>
      <el-radio v-model="jiage2" label="76-100">76-100</el-radio>
      <el-radio v-model="jiage2" label="100-999999">100以上</el-radio>
    </div>
    <div class="media-cell">
      平台认证：
      <el-radio v-model="isAuth" label="0">不限</el-radio>
      <el-radio v-model="isAuth" label="1">已认证</el-radio>
      <el-radio v-model="isAuth" label="2">未认证</el-radio>
    </div>
    <div class="tipsBox" style="width: 100%">{{ tips }}</div>

    <div
      style="
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 6px;
      "
    >
      <el-input
        style="width: 500px"
        v-model="sousuo"
        @keyup.enter.native="search(1)"
        placeholder="请输百科名称"
      >
        <template slot="prepend" style="background: #fff">百科名称：</template>
        <el-button
          slot="append"
          icon="el-icon-search"
          type="primary"
          @click="search"
          >搜索</el-button
        >
      </el-input>
      <el-button style="margin-left:10px" @click="onExpout">导出资源</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      row-key="id"
    >
      <el-table-column width="50%">
        <template slot-scope="scope">
          <i
            class="el-icon-circle-plus-outline"
            style="cursor: pointer"
            @click="addcar(scope.row, 'price', scope.row.price,scope.row.disPrice)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="业务名称">
        <template slot-scope="scope">
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="scope.row.mediaCase"
            >{{ scope.row.name }}</a
          >
        </template>
      </el-table-column>
      <el-table-column property="portal" label="所属平台"></el-table-column>
      <el-table-column property="channel" label="业务类型"></el-table-column>
      <el-table-column property="others" label="工作时间"></el-table-column>
      <!-- 首发价 转发价 微任务价 -->
      <el-table-column property="price" label="价格">
        <template slot-scope="scope">
          <a>{{ scope.row.price + scope.row.addPrice }}</a>
        </template>
      </el-table-column>
      <el-table-column property="auth" label="是否认证" width="80%">
        <template slot-scope="scope">
          <a v-if="scope.row.auth == '已认证'" class="yrz">
            {{ scope.row.auth }}
          </a>
          <a v-else class="wrz">{{ scope.row.auth }}</a>
        </template>
      </el-table-column>
      <!-- <el-table-column property="rate" label="出稿率"></el-table-column>
      <el-table-column property="speed" label="出稿速度"></el-table-column> -->

      <el-table-column property="remark" label="备注" width="600px">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="360"
            trigger="hover"
            :content="scope.row.remark"
          >
            <p class="over_text" slot="reference">
              {{ scope.row.remark }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="Pagination" style="text-align: left; margin-top: 10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import myAxios from "../../myAxios";

export default {
  data() {
    return {
      tips: localStorage.getItem("wikiTips"),
      isAuth: "0",
      more1: false,
      more2: false,
      loading: false,
      tableData: [],
      index: 1,
      size: 20,
      count: 0,
      sousuo: "",
      value: "",
      options: [],
      value2: "",
      options2: [],
      menhu2: ["不限"],
      zqy: "不限",
      pindao2: ["不限"],
      quyu2: "0",
      shoulu2: "0",
      jiage2: "0-999999",
      toufang2: ["不限"],
      other2: ["不限"],
      othersList: [
        {
          value: "不限",
          label: "不限",
        },
        {
          value: "工作日",
          label: "工作日",
        },
        {
          value: "周六日",
          label: "周六日",
        },
        {
          value: "节假日",
          label: "节假日",
        },
        {
          value: "提前预约",
          label: "提前预约",
        },
      ],
      portalList: [
        {
          label: "百度",
          value: "百度",
        },
        {
          label: "360",
          value: "360",
        },
        {
          label: "搜狗",
          value: "搜狗",
        },
        {
          label: "知乎",
          value: "知乎",
        },
        {
          label: "新浪",
          value: "新浪",
        },
        {
          label: "天涯社区",
          value: "天涯社区",
        },
        {
          label: "soso",
          value: "soso",
        },
        {
          label: "悟空",
          value: "百悟空度",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      channelList: [
        {
          value: "其他",
          label: "其他",
        },
        {
          value: "企业百科",
          label: "企业百科",
        },
        {
          value: "人物百科",
          label: "人物百科",
        },
        {
          value: "品牌百科",
          label: "品牌百科",
        },
        {
          value: "网站百科",
          label: "网站百科",
        },
        {
          value: "产品百科",
          label: "产品百科",
        },
        {
          value: "软件APP百科",
          label: "软件APP百科",
        },
        {
          value: "一问一答",
          label: "一问一答",
        },
        {
          value: "一问多答",
          label: "一问多答",
        },
        {
          value: "下拉词",
          label: "下拉词",
        },
        {
          value: "发帖",
          label: "发帖",
        },
        {
          value: "盖楼",
          label: "盖楼",
        },
      ],
    };
  },
  components: {},
  created() {
    this.initData();
  },
  methods: {
    onExpout() {
      var data = {
        username: localStorage.getItem("username"),
        mediaType: 5,
        index: this.index,
        size: this.count,
        priceStart: this.jiage2.split("-")[0],
        priceEnd: this.jiage2.split("-")[1],
        fansStart: 0,
        fansEnd: 99999,
        readingStart: 0,
        readingEnd: 99999,
        friendsStart: 0,
        friendsEnd: 99999,
        channels: this.pindao2,
        portals: this.menhu2,
        isAuth: this.isAuth,
        name: this.sousuo.replace(/\s*/g, ""),
      };
      if (data.channels && data.channels[0] == "不限") {
        data.channels = [];
      }
      myAxios.post(`/client_user/MediasExport/v1`, data).then((res) => {
        this.downloadLoading = false;
        const link = document.createElement("a");
        link.href = res.data;
        link.setAttribute("download", "导出数据");
        document.body.appendChild(link);
        link.click();
      });
    },
    onCheckbox_other2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.other2.shift();
      }
    },
    onCheckAll_other2(val) {
      // console.log(val)
      if (val) {
        this.other2 = ["不限"];
      }
    },
    onCheckbox_pindao2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.pindao2.shift();
        console.log(this.pindao2);
      }
    },
    onCheckAll_pindao2(val) {
      // console.log(val)
      if (val) {
        this.pindao2 = ["不限"];
      }
    },
    onCheckAll_menhu2(val) {
      // console.log(val)
      if (val) {
        this.menhu2 = ["不限"];
      }
    },
    onCheckbox_menhu2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.menhu2.shift();
        console.log(this.menhu2);
      }
    },
    // 搜索
    search(num) {
      if (num) {
        this.index = 1;
      }
      var data = {
        username: localStorage.getItem("username"),
        mediaType: 5,
        index: this.index,
        size: this.size,
        priceStart: this.jiage2.split("-")[0],
        priceEnd: this.jiage2.split("-")[1],
        fansStart: 0,
        fansEnd: 99999,
        readingStart: 0,
        readingEnd: 99999,
        friendsStart: 0,
        friendsEnd: 99999,
        channels: this.pindao2,
        portals: this.menhu2,
        isAuth: this.isAuth,
        others:this.other2,
        name: this.sousuo.replace(/\s*/g, ""),
      };
      if (data.channels && data.channels[0] == "不限") {
        data.channels = [];
      }
      myAxios.post(`/client_user/medias/v1`, data).then((res) => {
        this.tableData = res.data;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].auth) {
            this.tableData[i].auth = "已认证";
          } else {
            this.tableData[i].auth = "未认证";
          }
          //   if (this.tableData[i].contactable) {
          //     this.tableData[i].contactable = "是";
          //   } else {
          //     this.tableData[i].contactable = "否";
          //   }
          //   if (this.tableData[i].linkable) {
          //     this.tableData[i].linkable = "是";
          //   } else {
          //     this.tableData[i].linkable = "否";
          //   }
        }
        this.count = res.total;
      });
    },
    async initData() {
      try {
        this.getUsers();
      } catch (err) {
        console.log("获取数据失败");
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.search();
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
      // this.$refs.addHeight
      // this.oldval = val;
      // this.total = 0;
      // this.mediaIds = [];
      // if (val.length > 0) {
      //   for (var i = 0; i < val.length; i++) {
      //     this.total = this.total + val[i].price;
      //     this.mediaIds.push(val[i].id);
      //   }
      // }
      // this.car = "";
      // for (var i = 0; i < val.length; i++) {
      //   this.car = this.car + val[i].name;
      //   this.car = this.car + " ; ";
      // }
      // console.log(this.mediaIds);
    },
    async getUsers() {
      var data = {
        username: localStorage.getItem("username"),
        mediaType: 5,
        index: this.index,
        priceStart: 0,
        priceEnd: 99999,
        fansStart: 0,
        fansEnd: 99999,
        readingStart: 0,
        readingEnd: 99999,
        friendsStart: 0,
        friendsEnd: 99999,
        size: this.size,
      };
      myAxios.post(`/client_user/medias/v1`, data).then((res) => {
        this.tableData = res.data;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].auth) {
            this.tableData[i].auth = "已认证";
          } else {
            this.tableData[i].auth = "未认证";
          }
          //   if (this.tableData[i].contactable) {
          //     this.tableData[i].contactable = "是";
          //   } else {
          //     this.tableData[i].contactable = "否";
          //   }
          //   if (this.tableData[i].linkable) {
          //     this.tableData[i].linkable = "是";
          //   } else {
          //     this.tableData[i].linkable = "否";
          //   }
        }
        console.log(this.tableData);
        this.count = res.total;
      });

      this.loading = false;
    },
    addcar(val, str, pirce,disPrice) {
      this.$emit("addcar", val, str, pirce,disPrice);
    },
  },
};
</script>

<style lang="less">
.btn_bottom {
  position: fixed;
  bottom: 5px;
  right: 50px;
}

.table_container {
  padding: 20px;
}

.media-cell {
  position: relative;
  height: 30px;
  border-bottom-color: #eeeeee;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin-top: 10px;
}

.media-input {
  width: 200px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 8%;
}

.media-p1 {
  position: absolute;
  top: 0;
  left: 28%;
}

.media-select {
  position: absolute;
  top: 0;
  left: 35%;
}

.media-p2 {
  position: absolute;
  top: 0;
  left: 55%;
}

.media-p3 {
  position: absolute;
  top: 0;
  left: 85%;
}

.media-select2 {
  position: absolute;
  top: 0;
  left: 65%;
}

.choose-bottom {
  position: fixed;
  bottom: 0;
  left: 16%;
  padding-left: 2%;
  background-color: aliceblue;
  height: auto;
  line-height: 50px;
  width: 82%;
  font-weight: bold;
  font-size: 10pt;
}

.yrz {
  color: #fd5353;
  border: 1px solid #fd5353;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}

.wrz {
  background-color: #bdbdbd;
  color: #ffffff;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}

.over_text {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
